module.exports = __webpack_public_path__ + "static/img/new1.1b5a0fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new1.png
// module id = eCzq
// module chunks = 3